
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Index from "./pages/Index";
import PromptAssist from "./pages/PromptAssist";
import Pricing from "./pages/Pricing";
import History from "./pages/History";
import NotFound from "./pages/NotFound";
import PaymentSuccess from "./pages/payment/success";
import PaymentCancel from "./pages/payment/cancel";
import { useEffect } from "react";
import { initAnalytics } from "./lib/firebase";
import Blog from "./pages/Blog";
import ThePromptAssistStory from './pages/blog/ThePromptAssistStory';

// Initialize QueryClient
const queryClient = new QueryClient();

const App = () => {
  // Initialize analytics
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/prompt-assist" element={<PromptAssist />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/history" element={<History />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/the-promptassist-story" element={<ThePromptAssistStory />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
